import { createFileRoute } from "@tanstack/react-router";
import { StaticInfoPage } from "@/components/static-info-page";
import { CONTACT_CHANNEL } from "@/lib/business-info";

export const Route = createFileRoute("/copyright")({
  head: () => ({
    meta: [
      { title: "Bản Quyền - Quyền Sở Hữu Trí Tuệ Bói Đê" },
      {
        name: "description",
        content:
          "Thông tin bản quyền và quyền sở hữu trí tuệ của nền tảng huyền học Bói Đê. Tìm hiểu ngay!",
      },
    ],
  }),
  component: CopyrightPage,
});

function CopyrightPage() {
  return (
    <StaticInfoPage
      kicker="COPYRIGHT"
      title="Bản quyền"
      description="Thông tin về quyền sở hữu trí tuệ đối với thương hiệu, nội dung, giao diện và mã nguồn của Bói Đê."
      sections={[
        {
          title: "1. Chủ sở hữu",
          paragraphs: [
            "Thương hiệu Bói Đê cùng toàn bộ nội dung, giao diện, mã nguồn và tài sản số liên quan thuộc quyền sở hữu của Bói Đê.",
            "Tên gọi, biểu tượng, thiết kế giao diện, nội dung và tài sản số liên quan được bảo hộ theo quy định hiện hành.",
          ],
        },
        {
          title: "2. Quyền sử dụng nội dung",
          paragraphs: [
            "Người dùng được sử dụng nội dung do hệ thống tạo ra cho mục đích cá nhân, tham khảo và lưu trữ riêng.",
            "Không được sao chép, tái phân phối, thương mại hóa hoặc khai thác hàng loạt nội dung, giao diện hay dữ liệu của Bói Đê khi chưa có chấp thuận bằng văn bản.",
          ],
        },
        {
          title: "3. Báo cáo vi phạm",
          paragraphs: [
            `Nếu phát hiện hành vi sử dụng trái phép tài sản của Bói Đê hoặc cần yêu cầu cấp phép, vui lòng liên hệ qua ${CONTACT_CHANNEL}.`,
          ],
        },
      ]}
    />
  );
}
